export enum EAPIErrorType {
    NONE = 'NONE', // 表示 成功
    HTTP = 'HTTP', // 表示 非 200-299 的 http staus code
    BUSINESS = 'BUSINESS', // 表示 http 正常，但是接口响应的是 业务错误
    FE = 'FE', // 表示浏览器端出错
}

export interface IAPIBaseInfo {
    readonly method: string; // http请求使用的 method
    readonly path: string; // 接口地址
    readonly params: string; // 接口参数：queryString 或 json 字符串，如 body 的 json.stringify
    readonly time: number; // 接口耗时：单位为ms
    readonly errType: EAPIErrorType; // 错误类型
    readonly errno: number; // 错误码：0 表示没有错误
    readonly errmsg: string; // 错误信息
    readonly traceid: string; // traceid
}

export class APIBaseInfo {
    public readonly method: string; // http请求使用的 method
    public readonly path: string; // 接口地址
    public params: string = ''; // 接口参数：queryString 或 json 字符串，如 body 的 json.stringify
    public time: number = 0; // 接口耗时：单位为ms
    public errType: EAPIErrorType = EAPIErrorType.NONE; // 错误类型
    public errno: number = 0; // 错误码：0 表示没有错误
    public errmsg: string = ''; // 错误信息
    public traceid: string = ''; // traceid

    private timingEnded = false;

    constructor(p: Required<Pick<IAPIBaseInfo, 'method' | 'path'>>) {
        this.method = p.method;
        this.path = p.path;
    }

    public timingBegin() {
        if (this.timingEnded) {
            return;
        }
        this.time = new Date().getTime();
    }

    public timingEnd() {
        if (this.timingEnded) {
            return;
        }
        this.timingEnded = true;
        this.time = new Date().getTime() - this.time;
    }

    public get data(): IAPIBaseInfo {
        return {
            method: this.method,
            path: this.path,
            params: this.params,
            time: this.time,
            errType: this.errType,
            errno: this.errno,
            errmsg: this.errmsg,
            traceid: this.traceid,
        };
    }
}
